import { useTranslation } from 'react-i18next';

import { faXmarkCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { I18NextNS } from 'src/models/Language.model';

import StatusCardTemplate from './StatusCardTemplate';

export default function AnalysisFailedStatusCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'newExam.analyzingModal.statusCards.analysisFailed',
  });

  return (
    <StatusCardTemplate
      icon={<FontAwesomeIcon icon={faXmarkCircle} className="text-danger" />}
      iconBackgroundColor="danger-100"
      primaryText={t('primary')}
      secondaryText={t('secondary')}
      dataTest="status-analysis-failed"
    />
  );
}
